import React, { useCallback, useEffect, useState } from 'react';
const images = ['https://cdn.magicpatterns.com/uploads/1Pwk33va6Eq1vkQ5GQ2PGE/ChatGPT_Image_30_abr_2026,_18_26_58.png', 'https://cdn.magicpatterns.com/uploads/qMuz1mUaBbcv1gPQip5LoA/Captura_de_pantalla_2026-04-30_a_las_6.12.03_p._m..png', 'https://cdn.magicpatterns.com/uploads/4B4iTXDnjqz4rMRqo2iYzi/ChatGPT_Image_30_abr_2026,_21_11_58.png'];
export function ImageCarousel() {
  const [current, setCurrent] = useState(0);
  const next = useCallback(() => {
    setCurrent(prev => (prev + 1) % images.length);
  }, []);
  useEffect(() => {
    const interval = setInterval(next, 4000);
    return () => clearInterval(interval);
  }, [next]);
  return <section className="w-full bg-[#f9f8f4] pb-16 px-4 md:px-8" data-id="element-205">
      <div className="max-w-[900px] mx-auto" data-id="element-206">
        {/* Image */}
        <div className="relative overflow-hidden rounded-2xl" data-id="element-207">
          <div className="flex transition-transform duration-500 ease-in-out" style={{
          transform: `translateX(-${current * 100}%)`
        }} data-id="element-208">
            {images.map((src, index) => <div key={index} className="w-full flex-shrink-0" data-id="element-209">
                <img src={src} alt={`Viandas preparadas - imagen ${index + 1}`} className="w-full h-auto object-cover aspect-square" data-id="element-210" />
              </div>)}
          </div>
        </div>

        {/* Dots */}
        <div className="flex justify-center gap-2.5 mt-5" data-id="element-211">
          {images.map((_, index) => <button key={index} onClick={() => setCurrent(index)} aria-label={`Ir a imagen ${index + 1}`} className={`w-3 h-3 rounded-full transition-all duration-300 ${index === current ? 'bg-[#1e2330] scale-110' : 'bg-[#c5bfb3] hover:bg-[#9e9789]'}`} data-id="element-212" />)}
        </div>
      </div>
    </section>;
}